import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

const jsonHeaders = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  ...authHeaders(),
});

const normalizeFeatures = (value) => {
  if (Array.isArray(value)) return value.map((x) => String(x || '').trim()).filter(Boolean);
  if (typeof value === 'string') return value.split('\n').map((x) => x.trim()).filter(Boolean);
  return [];
};

export function mapPackageFromApi(d) {
  return {
    id: d.id,
    label: d.label ?? '',
    name: d.name ?? '',
    tagline: d.tagline ?? '',
    price: d.price ?? '',
    priceSub: d.priceSub ?? '',
    boardSeatsText: d.boardSeatsText ?? '',
    officerSeatsText: d.officerSeatsText ?? '',
    shareholderSeatsText: d.shareholderSeatsText ?? '',
    features: normalizeFeatures(d.features),
    buttonText: d.buttonText ?? '',
    buttonUrl: d.buttonUrl ?? '',
    isFeatured: Boolean(d.isFeatured),
    isActive: Boolean(d.isActive),
    sortOrder: Number(d.sortOrder ?? 0),
  };
}

export function mapPackageFormToPayload(form) {
  return {
    label: form.label?.trim() ?? '',
    name: form.name?.trim() ?? '',
    tagline: form.tagline?.trim() || null,
    price: form.price?.trim() ?? '',
    priceSub: form.priceSub?.trim() || null,
    boardSeatsText: form.boardSeatsText?.trim() ?? '',
    officerSeatsText: form.officerSeatsText?.trim() ?? '',
    shareholderSeatsText: form.shareholderSeatsText?.trim() ?? '',
    features: normalizeFeatures(form.featuresText),
    buttonText: form.buttonText?.trim() ?? '',
    buttonUrl: form.buttonUrl?.trim() || null,
    isFeatured: Boolean(form.isFeatured),
    isActive: Boolean(form.isActive),
    sortOrder: Number(form.sortOrder || 0),
  };
}

export async function fetchSuperAdminPackages() {
  const res = await fetch(`${API_BASE}/api/superadmin/packages`, { headers: { Accept: 'application/json', ...authHeaders() } });
  const data = await res.json().catch(() => ([]));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل الباقات'));
  return (Array.isArray(data) ? data : []).map(mapPackageFromApi);
}

export async function createSuperAdminPackage(payload) {
  const res = await fetch(`${API_BASE}/api/superadmin/packages`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر إضافة الباقة'));
  return mapPackageFromApi(data);
}

export async function updateSuperAdminPackage(id, payload) {
  const res = await fetch(`${API_BASE}/api/superadmin/packages/${id}`, {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحديث الباقة'));
  return mapPackageFromApi(data);
}

export async function deleteSuperAdminPackage(id) {
  const res = await fetch(`${API_BASE}/api/superadmin/packages/${id}`, {
    method: 'DELETE',
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  if (res.status === 204) return;
  const data = await res.json().catch(() => ({}));
  throw new Error(messageFromErrorBody(data, 'تعذر حذف الباقة'));
}
